import React from "react";
import { Box, HStack, Flex, Text, Avatar, Stack } from "@chakra-ui/react";

export default function MessageCard({imageUrl,name,onClick,message,time}) {
  return (
    <Box my={4} onClick={onClick} cursor="pointer">
      <Box py={4} px={4}>
        <Flex gap={4} >
          <Avatar src={imageUrl} size={{ base: "lg" }} alignItems="start">
          <Box
                as="span"
                pos="relative"
                left="-12px"
                top="2px"
                p="6px"
                fontSize="xs"
                fontWeight="bold"
                lineHeight="none"
                color="green.100"
                // transform="translate(50%,-50%)"
                bg="#00D900"
                rounded="full"
              />
          </Avatar>
          <Stack w="full" >
            <HStack alignItems={"center"} justifyContent="space-between" w="full">
              <Text
                fontSize={{ base: "12px", md: "16px", xl: "19px" }}
                fontWeight="semibold"
              >
                {name}
              </Text>
              
            </HStack>
            <Text color="#ababab" fontSize={{ base: "13px", xl: "16px" }} marginTop={0}>
              {message}
            </Text>
          </Stack>
          <Stack alignItems="end" fontSize="12px"  >
                <Text color="#ABABAB">
                  {time}
                </Text>
                {/* Unread */}
                <Text p={"2px"} w="20px" bg="#88B331" color="white" fontWeight="semibold" borderRadius={"full"} align="center">
                  2
                </Text>
              </Stack>
        </Flex>
      </Box>
    </Box>
  );
}
